import type { USSchoolForSubmission } from '@mote/api'

export type SurveyKey =
  | 'is_minor'
  | 'role'
  | 'educator_school'
  | 'professional_organization'
  | 'personal_use'

export type Choice = {
  icon?: string
  text: string
  value: string | boolean
}

type CommonQuestionValues = {
  key: SurveyKey
  trackingKey: string
  question: string
}

export interface QuestionValues extends CommonQuestionValues {
  choices: Choice[]
}

export type Role = 'student' | 'educator' | 'personal' | 'professional'

export enum OnboardingRoles {
  student = 'student',
  educator = 'educator',
  personal = 'personal',
  professional = 'professional'
}

export interface RoleChoice extends Choice {
  advanceTo: Role
}

export interface RoleQuestionValues extends CommonQuestionValues {
  choices: RoleChoice[]
}

export type InputQuestionValues = CommonQuestionValues

export type Answer = {
  question: CommonQuestionValues['question']
  label: Choice['text']
  value: Choice['value'] | USSchoolForSubmission
}

export type SchoolEntryType = 'search' | 'hint' | 'manual'
